import { render, staticRenderFns } from "./my-zjmx.vue?vue&type=template&id=0f42d122&scoped=true&"
import script from "./my-zjmx.vue?vue&type=script&lang=js&"
export * from "./my-zjmx.vue?vue&type=script&lang=js&"
import style0 from "./my-zjmx.vue?vue&type=style&index=0&id=0f42d122&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42d122",
  null
  
)

export default component.exports